import React, { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';

export const LinkWithQuery: FC<LinkProps> = ({ children, to, ...props }) => {
  return (
    <Link to={to} {...props}>
      {children}
    </Link>
  );
};
